import { FunctionComponent, MouseEvent } from "react";
import { Modal } from "antd";
import BasicButton from "@components/core/buttons/BasicButton";
import i18n from "i18next";

export interface BasicModalProps {
  title?: string | JSX.Element;
  visible: boolean;
  closable?: boolean;
  onOk?: (e?: MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e?: MouseEvent<HTMLButtonElement>) => void;
  showCancelButton?: boolean;
  showFooter?: boolean;
  footerTakeAllWidth?: boolean;
  buttonText?: string;
  className?: string;
  footer?: JSX.Element | null;
  destroyOnClose?: boolean;
  afterClose?: () => void;
  isLoading?: boolean;
  isClosableWhenClickingOutside?: boolean;
}

interface Props extends BasicModalProps {
  okButtonDisabled?: boolean;
  children: string | JSX.Element;
}

const BasicModal: FunctionComponent<Props> = ({
  title,
  visible,
  closable = true,
  onOk,
  okButtonDisabled,
  onCancel,
  showCancelButton = true,
  showFooter = true,
  footerTakeAllWidth = false,
  buttonText = i18n.t("buttons.ok"),
  children,
  className = "",
  destroyOnClose = false,
  afterClose,
  footer = showFooter ? (
    <div
      className={
        footerTakeAllWidth ? "modal-footer-button" : "modal-footer-buttons"
      }
    >
      {showCancelButton && (
        <BasicButton
          variant="secondary"
          text={i18n.t("buttons.cancel")}
          onClick={onCancel}
        />
      )}
      {onOk && (
        <BasicButton
          variant="primary"
          text={buttonText}
          onClick={onOk}
          disabled={okButtonDisabled}
        />
      )}
    </div>
  ) : null,
  isLoading = false,
  isClosableWhenClickingOutside = true,
}) => {
  return (
    <Modal
      centered
      title={<h5>{title}</h5>}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      className={`app-modal ${className}`}
      closable={closable}
      footer={footer}
      destroyOnClose={destroyOnClose}
      afterClose={afterClose}
      confirmLoading={isLoading}
      data-test={"modal"}
      maskClosable={isClosableWhenClickingOutside}
    >
      {children}
    </Modal>
  );
};

export default BasicModal;
